module.exports = __webpack_public_path__ + "static/media/Nema8.5afabf7c.jpg";